import React from "react";
import ServicePageLayout from "./ServicePageLayout";

const AppDevelopment = () => {
  return (
    <ServicePageLayout
      imageTitle={
        [
          "AI-Powered App Development Services for Smart Business Growth  "
        ]
      }
      heroImage="/appdevelopment-service.png"
      sectionTitle="Our App development services"
      description={[
        "Over 6 billion smartphone users globally 80% of time spent on mobile devices is within apps boost brand loyalty, sales, and customer experience from startups to enterprises, mobile apps have become essential to thrive in a competitive market. ",
      ]}
      benefitsTitle=""
      benefits={[
        "📱 Android App Development ",
        "📱 iOS App Development ",
        "🔁 Cross-Platform App Development",
        "🌐 Progressive Web Apps (PWA)",
        "⚙️ Custom App Development",
        "🧩 App UI/UX Design ",
        "🔒 App Maintenance & Support",
      ]}
      secondaryImage="/app-service-section.png"
      servicesTitle="Our App Development Process "
      services={[
        {
          title: "Discovery & Planning",
          desc: "We gather your requirements, define project goals, and plan the app architecture. ",
        },
        {
          title: "UI/UX Design",
          desc: "Wireframes, prototypes, and high-fidelity UI design aligned with your brand identity.",
        },
        {
          title: "Development",
          desc: "Our developers build the app with clean code, modular structure, and real-time collaboration.",
        },

        {
          title: "AI Integration",
          desc: "We embed machine learning models, NLP, and automation to make your app smarter.",
        },
        {
          title: "Testing & QA",
          desc: "Every feature is tested on real devices to ensure flawless performance.",
        },
        {
          title: "Deployment",
          desc: "We publish your app on Google Play Store, Apple App Store, or enterprise portals.",
        }
      ]}
    />
  );
};

export default AppDevelopment;
